import { LayoutTemplate, TemplateGroup } from '../layoutTemplates.types.ts';
import { PageNames } from '../pageNames.ts';

/** Special camera/video layouts (spans and weighted rows), not tied to one screen shape. */
export const videoTemplates: LayoutTemplate[] = [
  {
    id: 'cameras',
    name: 'cameras',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // 4 × 3 grid; the top-left 2 × 2 block is merged into one widget.
    spec: {
      areas: `
        A A B C
        A A D E
        F G H I
      `,
    },
  },
  {
    id: 'main-video',
    name: 'main-video',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // A large 3 × 3 main cell on the left, three stacked cells on the right.
    spec: {
      areas: `
        A A A B
        A A A C
        A A A D
      `,
    },
  },
  {
    id: 'camera-duo',
    name: 'camera-duo',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // Two half-width cells on top (height 21), four quarter-width below (height 12).
    spec: {
      areas: `
        A A B B
        C D E F
      `,
      rowWeights: [21, 12],
    },
  },
  {
    id: 'camera-duo-two-top',
    name: 'camera-duo-two-top',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // Two half-width cells on top (height 21), four quarter-width below (height 12).
    spec: {
      areas: `
        A A A B B B
        C C D D E E
      `,
      rowWeights: [21, 12],
    },
  },
  {
    id: 'camera-duo-two-left',
    name: 'camera-duo-two-left',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // Two half-width cells on top (height 21), four quarter-width below (height 12).
    spec: {
      areas: `
        A C
        A C
        A D
        B D
        B E
        B E
      `,
    },
  },
  {
    id: 'three-by-two',
    name: 'three-by-two',
    group: TemplateGroup.Video,
    pageName: PageNames.Dashboard,
    // Two rows of three equal cells (equal is the default when no weights are given).
    spec: {
      areas: `
        A B C
        D E F
      `,
    },
  },
];
